import type { ReactNode } from "react";
import styled from "styled-components";
import { Color } from "src/elements";
import { useTranslation } from "src/i18n";

export interface OSummaryItem {
  key: string;
  text: string;
}

const Line = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  margin: 10px;
  background: ${Color.greenSmokeDisabled};
  border: 1px solid ${Color.greenSmoke};
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
  color: ${Color.textMain};
`;

export const OMark = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 4px solid ${Color.primary};
  border-top-color: ${Color.primaryActive};
  box-sizing: border-box;
  background: ${Color.white};
`;

const Body = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Sentences = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
`;

export const OSummary = ({
  items,
  action,
  children,
}: {
  items: OSummaryItem[];
  action?: ReactNode;
  children?: ReactNode;
}) => {
  const { t } = useTranslation("common");
  return (
    <Line>
      <OMark aria-hidden="true" />
      <Body>
        <Sentences role="note" aria-label={t("planogramRules.dividers.oSummary")}>
          <span>
            {items.map((item, index) => (
              <span key={item.key} data-summary-item={item.key}>
                {index > 0 ? " " : ""}
                {item.text}
              </span>
            ))}
          </span>
          {action}
        </Sentences>
        {children}
      </Body>
    </Line>
  );
};
